export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7177_94495)">
                <path
                    d="M12.3841 24.3751C12.4171 25.0078 12.9382 25.5 13.5717 25.5H18.415C19.0524 25.5 19.5751 25.002 19.6049 24.3653C19.7116 22.0894 19.9253 19.03 21.3733 17.6149C22.7405 16.2848 23.5041 14.4971 23.5 12.6366C23.5 8.70157 20.1358 5.5 16.0002 5.5C11.8518 5.5 8.55766 8.59091 8.501 12.5364C8.48491 13.469 8.66226 14.3954 9.02292 15.2627C9.38358 16.13 9.92045 16.9212 10.6028 17.5908C12.0497 19.0173 12.2649 22.0927 12.3841 24.3751Z"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path d="M18 26C18 27.1046 17.1046 28 16 28C14.8954 28 14 27.1046 14 26" stroke="black" strokeWidth="1.2" />
                <line x1="12" y1="22.9" x2="20" y2="22.9" stroke="black" strokeWidth="1.2" />
                <path d="M6 11.5H4" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
                <path d="M26 11.207H28" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
                <path d="M6.70312 8.20703L5.28891 6.79282" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
                <path d="M25.2969 7.91406L26.7111 6.49985" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
                <path d="M6.70312 14.5L5.28891 15.9142" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
                <path d="M25.2969 14.207L26.7111 15.6212" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
                <path d="M17.5996 15.9004V22.0996H14.9004V15.9004H17.5996Z" stroke="black" strokeWidth="0.8" />
                <path
                    d="M18.5 13.9004C19.1075 13.9004 19.5996 14.3925 19.5996 15C19.5996 15.6075 19.1075 16.0996 18.5 16.0996H17.4004V15C17.4004 14.3925 17.8925 13.9004 18.5 13.9004Z"
                    stroke="black"
                    strokeWidth="0.8"
                />
                <path
                    d="M14 13.9004C13.3925 13.9004 12.9004 14.3925 12.9004 15C12.9004 15.6075 13.3925 16.0996 14 16.0996H15.0996V15C15.0996 14.3925 14.6075 13.9004 14 13.9004Z"
                    stroke="black"
                    strokeWidth="0.8"
                />
            </g>
            <defs>
                <clipPath id="clip0_7177_94495">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
